import React, { useEffect, useState } from "react";
import { PreviewAltCard } from "../../../components/Component";
import { Spinner } from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const JobStatistics = ({ jobCount }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!jobCount) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [jobCount]);
  const onMove = (status) => {
    history.push({
      pathname: `${process.env.PUBLIC_URL}/jobs`,
      state: {
        status: status,
        isJobListMove: true,
      },
    });
  };
  return (
    <React.Fragment>
      <PreviewAltCard className="card-full">
        {loading ? (
          <div className="spinner-container-statistics">
            <Spinner className="spinner-border-md" color="primary" />
          </div>
        ) : (
          <div>
            <div className="card-title-group align-start pb-3 g-2">
              <div className="card-title card-title-sm">
                <h6 className="title">Jobs</h6>
              </div>
            </div>
            <div className="analytic-au">
              <div className="analytic-data-group analytic-au-group g-3">
                <div className="analytic-data analytic-au-data cursor-pointer" onClick={() => onMove("OPEN")}>
                  <div className="title">Open</div>
                  <div className="amount">{jobCount?.open ?? 0}</div>
                </div>
                <div
                  className="analytic-data analytic-au-data cursor-pointer text-center"
                  onClick={() => onMove("APPLIED")}
                >
                  <div className="title">Applied</div>
                  <div className="amount">{jobCount?.applied ?? 0}</div>
                </div>
                <div
                  className="analytic-data analytic-au-data cursor-pointer text-end"
                  onClick={() => onMove("BOOKED")}
                >
                  <div className="title">Booked</div>
                  <div className="amount">{jobCount?.booked ?? 0}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </PreviewAltCard>
    </React.Fragment>
  );
};
export default JobStatistics;
